/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LedgerWithdrawOptions,
  LedgerWithdrawStatus201,
  LedgerWithdrawStatus400,
  LedgerWithdrawStatus403,
  LedgerWithdrawStatus500,
} from '../types/LedgerWithdraw'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { ledgerWithdraw } from '../clients/ledgerWithdraw'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const ledgerWithdrawMutationKey = () => [{ url: '/v1/ledger/withdraw/:user_id' }] as const

export function ledgerWithdrawMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = ledgerWithdrawMutationKey()
  return mutationOptions<
    LedgerWithdrawStatus201,
    ResponseErrorConfig<
      LedgerWithdrawStatus400 | LedgerWithdrawStatus403 | LedgerWithdrawStatus500
    >,
    LedgerWithdrawOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return ledgerWithdraw({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Withdraw assets from this user's account to the outside world. Note that this does not interact with any external systems; it simply deducts the amount from the user's available balance in the ledger. Actual transfer of assets must be handled separately.
 * @summary Withdraw assets from this user to the outside world
 * {@link /v1/ledger/withdraw/:user_id}
 */
export function useLedgerWithdraw<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LedgerWithdrawStatus201,
      ResponseErrorConfig<
        LedgerWithdrawStatus400 | LedgerWithdrawStatus403 | LedgerWithdrawStatus500
      >,
      LedgerWithdrawOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? ledgerWithdrawMutationKey()

  const baseOptions = ledgerWithdrawMutationOptions(config) as UseMutationOptions<
    LedgerWithdrawStatus201,
    ResponseErrorConfig<
      LedgerWithdrawStatus400 | LedgerWithdrawStatus403 | LedgerWithdrawStatus500
    >,
    LedgerWithdrawOptions,
    TContext
  >

  return useMutation<
    LedgerWithdrawStatus201,
    ResponseErrorConfig<
      LedgerWithdrawStatus400 | LedgerWithdrawStatus403 | LedgerWithdrawStatus500
    >,
    LedgerWithdrawOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LedgerWithdrawStatus201,
    ResponseErrorConfig<
      LedgerWithdrawStatus400 | LedgerWithdrawStatus403 | LedgerWithdrawStatus500
    >,
    LedgerWithdrawOptions,
    TContext
  >
}
